module.exports = __webpack_public_path__ + "img/T906.2181fc90.jpg";